<template>
  <v-dialog
    v-model="show"
    width="350"
    persistent
    @keydown.esc="closeModal"
  >
    <v-card elevation="0">
      <v-card-title class="app-card-title">
        <span>Confirmar Exclusão</span>
      </v-card-title>
      <v-card-text class="app-card-content pb-0">        
        <p class="mb-7">  
          Tem certeza de que deseja desvincular o tipo de documento 
          <strong>{{ item.type_document.name }}</strong> deste tipo de pedido?          
        </p>

        <span class="app-form__warning">
          Atenção: Após confirmar, esta ação <em>não poderá</em> ser desfeita!
        </span>
      </v-card-text>  
      <v-divider />
      <v-card-actions>
        <v-spacer />       
        <v-btn
          text
          color="error"
          @click="closeModal"
        >
          Cancelar
        </v-btn>
        <v-btn
          text
          color="success"
          @click="deleteFunctionality"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import TipoPedidoService from '@/services/tipo-pedido.service';

  export default {
    name: 'TypeSolicitationTypeDocumentDeleteModal',

    props: {
      item: {
        type: Object,
        required: true,
      },
    },
  
    data: () => ({ 
      show: true     
    }),

    methods: {
      closeModal() {
        this.show = false;
        this.$emit('close');
      },
      
      deleteFunctionality() {
        const { type_solicitation, type_document } = this.item;
        
        TipoPedidoService
          .removeDocumentType(type_solicitation.id, type_document.id)
          .subscribe(() => {
            this.$emit('close');
            this.$emit('deleted');
          });
      }
    }
  }
</script>